module.exports = __webpack_public_path__ + "img/atom-store.cc8dfadc.svg";